import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/access-denied")({
  staticData: { title: "Access Denied" },
  component: lazyRouteComponent(
    () => import("#pages/login/access-denied.tsx"),
    "AccessDenied",
  ),
})
